import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ICallableObject, IRequestCallback } from '@df/api/request/request.service';
import { Status } from '@df/core/status';
import { MuiInputDirective } from '@df/legacy/ui/form/mui-input.directive';
import { ZippyModule } from '@df/legacy/ui/zippy/zippy.module';
import { Giftcards } from '@df/module-giftcards/giftcards';
import { Basket } from '@df/session/api/basket/basket';
import { NOTICES } from '@df/ui/api/notice/notice.const';
import { ValuesPipe } from '@df/ui/common/values.pipe';
import { AbstractFormComponent } from '@df/ui/form/abstract-form.component';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { GiftcardsAddedGiftcardComponent } from '../../basket/giftcards-added-giftcard.component';
import { ActionComponent } from '../../ui/api/action.component';
import { InputWrapBodyDirective } from '../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../ui/form/input-wrap.component';
import { ResultComponent } from '../../ui/resut/result.component';
NOTICES['INVALID_GIFTCARD'] = `Sorry, we don't recognise this code`;
NOTICES['INCORRECT_PIN'] = 'Please enter correct pin number';
interface IGiftcardsFormData {
    code: string;
    checkout?: boolean;
}
@Component({
    selector: 'giftcards-form',
    templateUrl: './giftcards-form.html',
    standalone: true,
    imports: [
        ActionComponent,
        FormsModule,
        GiftcardsAddedGiftcardComponent,
        InputWrapComponent,
        InputWrapBodyDirective,
        MuiInputDirective,
        PriceComponent,
        ValuesPipe,
        ResultComponent,
        TranslationModule,
        ZippyModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GiftcardsFormComponent extends AbstractFormComponent<IGiftcardsFormData> implements OnInit {
    balanceStatus = new Status();
    balance: number | undefined;
    protected submitPath = Giftcards.Endpoints.Add;

    @Input()
    isCheckout?: boolean;

    basket = inject(Basket);

    override ngOnInit() {
        super.ngOnInit();
        this.subscriptions.add(this.basket.subscribe(() => this.detectChanges()));
        this.subscriptions.add(this.balanceStatus.subscribe(() => this.detectChanges()));
    }
    get hasBalance(): boolean {
        return this.balance !== undefined;
    }
    checkBalance(): void {
        if (this.form.valid) {
            this.updateBalance(undefined);
            this.status.reset();
        }
        this.requestService.submitForm<Giftcards.IBalanceCheckResponse>(
            this.form,
            this.balanceStatus,
            {
                path: Giftcards.Endpoints.Balance,
                data: {
                    code: this.data.code
                }
            },
            response => {
                if (this.data.code && response) {
                    this.updateBalance(response.balance);
                }
            },
            () => {
                if (this.form) {
                    this.form['submitAttempt'] = false;
                }
            }
        );
    }
    override submit(onSuccess: IRequestCallback = []): void {
        if (this.form.valid) {
            this.balanceStatus.reset();
        }
        super.submit(onSuccess, () => {
            if (this.form) {
                this.form['submitAttempt'] = false;
            }
        });
    }
    protected override getSubmitAction() {
        const superSubmitAction = super.getSubmitAction() as ICallableObject;
        if (this.isCheckout) {
            superSubmitAction.path = Giftcards.Endpoints.CheckoutAdd;
        }
        return superSubmitAction;
    }
    protected override onSubmitSuccess(response?: any): void {
        this.updateBalance(undefined);
        super.onSubmitSuccess(response);
    }
    protected updateBalance(value: number | undefined): void {
        this.balance = value;
        this.detectChanges();
    }
    trackByGiftcard(index: number, giftcard: Giftcards.IAddedGiftcardData) {
        return giftcard.code;
    }
}
